import * as React from 'react';

import { withIntl, IntlProps } from 'ha/i18n';
import Button from 'ha/ui/next/Button';
import Grid from 'ha/ui/next/Grid';
import HowItWorksLink from './HowItWorksLink';
import AuthModalActions from '../containers/AuthModalActions';

export const UnauthenticatedNavigation: React.SFC<IntlProps> = ({
  intl: { T },
}) => (
  <AuthModalActions>
    {({ onRegisterClick, onLoginClick }) => (
      <Grid item>
        <HowItWorksLink />
        <Button
          data-test-locator="Register button"
          onClick={onRegisterClick}
          variant="text"
        >
          {T('Sign up')}
        </Button>
        <Button
          data-test-locator="Login button"
          onClick={onLoginClick}
          variant="text"
        >
          {T('Log in')}
        </Button>
      </Grid>
    )}
  </AuthModalActions>
);

export default withIntl(UnauthenticatedNavigation);
